import React, { useEffect } from 'react';
import { Modal, Col, Row } from 'antd';
import { TransactionsActions } from '@portal/actions';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';

import { translate } from '@portal/services/i18n';
import { useDispatch } from 'react-redux';
import useReduxState from '@portal/hooks/useReduxState';
import AdvancedAutocomplete from '../AdvancedAutocomplete/AdvancedAutocomplete';
import CurrencyInputMask from 'react-currency-input';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  amount: string | number;
  setAmount: (visible: string | number) => void;
  reason: string;
  onChange: (value: string) => void;
  onConfirmation: () => void;
  setRawAmount: (visible: number) => void;
}

const PixReversalModal = ({
  visible,
  setVisible,
  onChange,
  reason,
  onConfirmation,
  amount,
  setAmount,
  setRawAmount,
}: IProps) => {
  const {
    transactions: { pixReversalReason },
  } = useReduxState();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!pixReversalReason || pixReversalReason.length === 0) {
      dispatch(TransactionsActions.getPixReversalReasons());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectOptionsFormatter = () => {
    if (pixReversalReason) {
      return pixReversalReason.map((value) => ({
        value: value.code,
        name: value.description,
      }));
    } else {
      return [];
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={() => setVisible(false)}
      footer={null}
      title={null}
      closable={false}
      className="pix-portability-modal"
    >
      <Row>
        <Col>
          <h3>{translate('COMPONENTS.PIX_REVERSAL_MODAL.TITLE')}</h3>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col span={24}>
          <CurrencyInputMask
            className="limit-pix-modal__currency-mask-input"
            autoFocus
            value={amount}
            onChange={(value, rawValues) => {
              setRawAmount(rawValues ?? 0);
              setAmount(value ?? '0');
            }}
            decimalSeparator={translate('SHARED.CURRENCY.DECIMAL_SEPARATOR')}
            thousandSeparator={translate('SHARED.CURRENCY.THOUSAND_SEPARATOR')}
            prefix={translate('SHARED.CURRENCY.SYMBOL')}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col span={24}>
          <AdvancedAutocomplete
            variant="standard"
            label={translate('COMPONENTS.PIX_REVERSAL_MODAL.REASON')}
            onChange={(value) => {
              if (typeof value === 'string') {
                onChange(value);
              }
            }}
            options={selectOptionsFormatter()}
            className="full-width-autocomplete"
          />
        </Col>
      </Row>
      <Row justify="end">
        <Col>
          <AdvancedButton
            text={translate('COMPONENTS.ADVANCED_BUTTON.ADVANCE')}
            onClick={() => {
              setVisible(false);
              onConfirmation();
            }}
            disabled={!reason}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default PixReversalModal;
